<template lang="pug">
#modalCreateMembers.modal.fade(ref="modal")
  .modal-dialog.modal-lg
    .modal-content
      .modal-header
        button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
        h4.modal-title {{group && group.name}} : {{$t("groups.createMembersModal.title")}}
      template(v-if="group && group.members && !group.members.canEditMembers")
        .modal-body
          .alert.alert-warning {{$t("groups.createMembersModal.noSuffisantRight")}}
      template(v-else)
        .modal-body
          template(v-if='savingState == null')
           template(v-if='this.firstSelectedGroop')
            template(v-if='this.firstSelectedGroop.autoInscription && this.firstSelectedGroop.autoInscription.method')
              auto-inscription(:groop='firstSelectedGroop')
              .text-center.text-muted
                a.btn.btn-xs.btn-default(@click='goToManagement') {{$t("groups.createMembersModal.changeAutoInscription")}}
            template(v-else)
              .alert.alert-info {{$t('groups.createMembersModal.wantToTryAutoInscription')}}
                .text-center.text-muted
                  a.btn.btn-xs.btn-default(@click='goToManagement') {{$t("groups.createMembersModal.changeAutoInscription")}}
            template(v-if='this.firstSelectedGroop.autoInscription && this.firstSelectedGroop.autoInscription.method')
              hr
              h4 {{$t("groups.createMembersModal.subtitle")}}
            form.form-horizontal(role="form")
              template(v-if='onBatchMembers')
                .form-group
                  .col-sm-12
                    label {{$t("groups.createMembersModal.fields.emails.label")}}
                    textarea.form-control(v-model='emails', :placeholder='$t("groups.createMembersModal.fields.emails.placeholder")', rows='10')
                .form-group
                  label.col-sm-2 {{$t("groups.createMembersModal.fields.emailsRole.label")}}
                  .col-sm-10
                    select.form-control(v-model='emailsRole')
                      option(v-for='role in roles', :value='role') {{$t("groupManagement.roles." + role)}}
                    p.help-block 
                      i.fa.fa-info-circle
                      |  {{$t("groupManagement.roles.explanation." + emailsRole)}}

              template(v-if='onFineMembers')
                .form-group.memberLine(v-for='m in members')
                  i.fa.fa-times-circle.removeBtn(role='button', @click='remove(m)')
                  template(v-if='m.id')
                    .col-sm-9
                      vue-object-img.fine(:object="m")
                      |  {{m.name}}
                  template(v-else)
                    .col-sm-4
                      input.form-control.text(v-model='m.name', required, :placeholder='$t("groups.createMembersModal.fields.member.name.placeholder")')
                    .col-sm-5
                      input.form-control.text(type='email', v-model='m.email', :placeholder='$t("groups.createMembersModal.fields.member.email.placeholder")')
                  .col-sm-3
                    select.form-control(v-model='m.role')
                      option(v-for='role in roles', :value='role') {{$t("groupManagement.roles." + role)}}
                auto-complete-user(showGroops="mine", showUsers="all", :placeholder='$t("groups.createMembersModal.fields.nameField.placeholder")', @select="addUserFromAutocomplete", :acceptNewUser='true', :acceptNewGroop='false', :container='$refs.modal.getElementsByClassName("modal-body")[0]', ref='autoCompleteUser')
                //- i.fa.fa-times(@click=' removeMember(m)')
              template(v-if="onEditInvitationText")
                .form-group
                  .col-sm-12
                    label {{$t("groups.createMembersModal.fields.invitationText.label")}}
                    textarea.form-control(v-model='invitationText', :placeholder='$t("groups.createMembersModal.fields.invitationText.placeholder")', rows='10')

          .bigIconMessage(v-if='savingState == "saving"')
            i.fa.fa-refresh.fa-spin.grey
            |  {{$t("globals.sending")}}
          .bigIconMessage(v-if='savingState == "saved"')
            i.fa.fa-check.green
            |  {{$t("globals.created")}}

          .bigIconMessage(v-if='savingState == "error"')
            i.fa.fa-remove.red
            |  {{$t("globals.error")}}

        .modal-footer(v-if='savingState == null')
          button.btn.btn-default.pull-left(type="button", @click=' cancel', v-if='onEditInvitationText') 
            template(v-if='onFineMembers || onEditInvitationText') {{$t('globals.previous')}}
            template(v-if='onBatchMembers') {{$t('globals.cancel')}}
          //- button.btn.btn-warning.pull-left(type="button") Sauver comme brouillon
          button.btn.btn-primary(type="button", :class='{disabled: !mustHaveIsComplete}', @click='createMembers')
            template(v-if='onEditInvitationText') {{$t('globals.create')}}
            template(v-if='onBatchMembers || onFineMembers') {{$t('globals.next')}}
</template>
<script>
import {mapGetters} from 'vuex'

import $ from 'jquery'
import modalsBus from '@/components/shared/ModalsBus'
import _ from 'lodash'
import api from '@/utils/api'

import AutoCompleteUser from '@/components/shared/AutoCompleteUser'
import VueObjectImg from '@/components/shared/VueObjectImg'
import AutoInscription from './AutoInscription'

export default {
  components: {
    AutoCompleteUser,
    AutoInscription,
    VueObjectImg
  },
  data () {
    return {
      savingState: null,
      emails: null,
      emailsRole: 'Administrator',
      members: [],
      step: '',
      invitationText: this._i18n.t('groups.createMembersModal.fields.invitationText.defaultText'),
      roles: ['Administrator', 'SimpleUser', 'Manager', 'Remplacant']
    }
  },
  mounted () {
    modalsBus.onOpen((arg, object) => {
      if (arg === modalsBus.modals.CREATE_MEMBERS) {
        this.show(object)
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    ...mapGetters('groops', [
      'isAllGroopsSelected',
      'firstSelectedGroop',
      'isPersonalGroopSelected'
    ]),
    mustHaveIsComplete () {
      return this.members.length > 0 && this.members.find((m) => !m.email && !m.name) === undefined
    },
    group () {
      if (this.isAllGroopsSelected || this.isPersonalGroopSelected) {
        return null
      }
      return this.firstSelectedGroop
    },

    onFineMembers () { return this.step === 'fineMembers' },

    onBatchMembers () { return this.step === 'batchMembers' },

    onEditInvitationText () { return this.step === 'editInvitationText' }
  },

  methods: {
    show () {
      this.$nextTick(() => {
        $(this.$refs.modal).modal('show')
        this.step = 'fineMembers'
      })
    },
    goToManagement () {
      this.closeModal()
      this.$router.push({name: 'GroupManagement', params: {groupId: this.firstSelectedGroop.id, anchor: 'autoInscription'}})
    },
    closeModal () {
      return $(this.$refs.modal).modal('hide')
    },
    addUserFromAutocomplete (element) {
      if (this.$refs.autoCompleteUser.isGroup(element)) {
        api.get('/group/' + element.id + '/members').then((response) => {
          _.forEach(response.data.members, (m) => {
            if (_.findIndex(this.members, {id: m.id}) === -1 && m.id !== this.user.id) {
              this.$set(m, 'role', this.roles[0])
              this.members.push(m)
            }
          })
        })
        return
      }
      this.$set(element, 'role', this.roles[0])
      if (this.$refs.autoCompleteUser.isNewUser(element)) {
        element.id = null
      }
      this.members.push(element)
    },
    remove (member) {
      this.members = this.members.filter((m) => { return m !== member })
    },
    createMembers () {
      let name
      if (!this.mustHaveIsComplete) {
        return
      }
      if (this.members.length === 0) {
        this.members = []
        if (this.members.length === 0) {
          const namesAndEmails = this.emails.match(/([^\n\r,]+)/g)
          for (let nameAndEmail of Array.from(namesAndEmails)) {
            if (nameAndEmail.trim() === '') {
              continue
            }
            let email = ''
            name = ''
            for (let part of Array.from(nameAndEmail.match(/([^\s]+)/g))) {
              if ((email === '') && (part.match(/.+@.+\..+/) != null)) {
                email = part
              } else {
                if (name !== '') {
                  name += ' '
                }
                name += part
              }
            }
            if (((name[0] === '"') && (name[name.length - 1] === '"')) || ((name[0] === '“') && (name[name.length - 1] === '”'))) {
              name = name.substr(1, name.length - 2)
            }
            if ((name[0] === '<') && (name[name.length - 1] === '>')) {
              name = name.substr(1, name.length - 2)
            }
            if (((email[0] === '"') && (email[email.length - 1] === '"')) || ((email[0] === '“') && (email[email.length - 1] === '”'))) {
              email = email.substr(1, email.length - 2)
            }
            if ((email[0] === '<') && (email[email.length - 1] === '>')) {
              email = email.substr(1, email.length - 2)
            }
            if (((email !== '') && (name === '')) || (email === name)) {
              name = email.match(/.+(?:@)/)[0]
              name = _.startCase(name.match(/([^.]+)/g).join(' '))
            }
            this.members.push({
              name,
              email,
              role: this.emailsRole
            })
          }
          if (this.members.length > 0) {
            this.step = 'fineMembers'
          }
        }
      } else { // create members on server
        if (this.step === 'fineMembers' && this.members.find((m) => m.email !== '' && m.email !== undefined)) {
          this.step = 'editInvitationText'
        } else {
          for (let m of Array.from(this.members)) {
            if (m.name === '') {
              alert('Tous les noms doivent être renseignés. Merci de les compléter.')
              return
            }
          }
          this.savingState = 'saving'
          api.post(`group/${this.group.id}/members`,
            {
              infos: this.members,
              defaultLg: 'fr',
              invitationText: this.invitationText
            }).then(response => {
              this.savingState = 'saved'
              this.group.members = null
              setTimeout(() => {
                this.savingState = null
                this.members = []
                this.step = 'batchMembers'
                this.emails = ''
                this.closeModal()
              }
            , 500)
            }).catch(response => {
              this.savingState = 'error'
              setTimeout(() => {
                this.savingState = null
              }
            , 2000)
            })
        }
      }
    },

    removeMember (member) {
      this.members.splice(this.members.indexOf(member), 1)
    },

    cancel () {
      if (this.onEditInvitationText) {
        this.step = 'fineMembers'
      } else if (this.onFineMembers) {
        this.members = []
        this.step = 'batchMembers'
      } else {
        this.emails = ''
        this.closeModal()
      }
    }
  }
}
</script>
<style lang="sass">
#modalCreateMembers
  .fine.profileImage
    height: 25px
    line-height: 25px
    width: 25px
    margin-top: 5px
  .removeBtn
    position: absolute
    left: -15px
    top: 10px
  .memberLine
    margin-left: 20px
    position: relative
</style>



// WEBPACK FOOTER //
// NewMembers.vue?924a21d4